// src/api/gradeApi.js
import axios from "axios";

const API_URL = "/api/grades";

export const getGrades = async () => {
  try {
    const { data } = await axios.get(API_URL);
    return data;
  } catch (error) {
    console.error("Error fetching grades:", error);
    throw error;
  }
};

export const addGrade = async (payload) => {
  try {
    const { data } = await axios.post(API_URL, payload);
    return data;
  } catch (error) {
    console.error("Error adding grade:", error);
    throw error;
  }
};

export const editGrade = async (id, payload) => {
  try {
    const { data } = await axios.put(`${API_URL}/${id}`, payload);
    return data;
  } catch (error) {
    console.error(`Error editing grade ${id}:`, error);
    throw error;
  }
};

export const deleteGrade = async (id) => {
  try {
    const { data } = await axios.delete(`${API_URL}/${id}`);
    return data;
  } catch (error) {
    console.error(`Error deleting grade ${id}:`, error);
    throw error;
  }
};
